<script>
	import Loading from "@/components/layout/Loading.vue";

	export default {
		components: {
			Loading
		},
		props: {
			data: {
				type: Array,
				required: true
			},
			loading: {
				type: Boolean,
				required: true
			}
		},
		methods: {
			capturaColaborador(item) {
				this.$emit('capturaColaborador', item);
				this.data.forEach(element => {
					element.active = false;
					if(element.id_usuario === item.id_usuario) element.active = true;
				});
			},
		},
		mounted() {	
			setTimeout(() => this.data[0].active = true, "1000");
		}
	}
</script>
<template>
	<section id="colaboradores-list">
		<Loading 
            v-if="loading"
            pixeles="100px"
        />
		<div 
			v-if="!loading"
			class="card border-0 overflow-600 card-shadow mb-3">
			<div class="card-body">
				<div class="list-group list-group-custom list-group-flush">
					<a 
						v-for="item in data"
						:key="item.id_usuario"
						@click="capturaColaborador(item)"
						href="javascript:" 
						class="list-group-item list-group-item-action"
						:class="item.active ? 'active-gray': '' "
					>
						<div class="d-flex">
							<div class="flex-shrink-0">
							<img 
								width="60"
								height="60"
								class="img-object-cover rounded-circle"
								v-if="item.imagen_perfil ||/.jpg|.jpeg|.png/.test(item.imagen_perfil)"
								:src="item.imagen_perfil"
							>
							<img
								v-else
								src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
								width="60"
								height="60"
								class="img-object-cover rounded-circle"
							/>
							</div>
							<div class="flex-grow-1 ms-3">
								<h6 class="font-main font-700 mb-1 text-secondary">
									{{capitalizeFirstLetter(item.primer_nombre) }}
									{{ capitalizeFirstLetter(item.apellido_paterno) }}
								</h6>
								<p class="text-secondary text-opacity-75 mb-0">
									Cargo: {{capitalizeFirstLetter(item.cargo[0].nombre_cargo) }}<br/>
									Lugar de trabajo: {{capitalizeFirstLetter(item.sucursal[0].nombre_sucursal) }}
								</p>
							</div>
						</div>
					</a>
				</div>
			</div>
		</div>
	</section>
</template>
<style lang="">
	
</style>